//reload 1

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';

// css
import '../css/main.scss';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index.js